import WechatJSSDK from 'wechat-jssdk/dist/client.umd'
import http from './request'

let myWx = {
  wechatObj: null,
  dufaultUrl: 'http://huachen.ihwasun.com/api/share.php',
  dufaultParam: {
    title: '荐面有礼丨与你最想见的人相见',
    link: 'http://huachen.ihwasun.com/html5/Ligao/20200320miss/index.html',
    imgUrl: 'http://huachen.ihwasun.com/html5/Ligao/20200320miss/images/thumb.jpg',
    desc: '春光明媚，不见不散',
    successCallback: ''
  },
  wxInitFn: function () {
    return new Promise((resolve, reject) => {
      if (this.wechatObj != null) {
        this.wxShareFn()
        resolve(this.wechatObj)
      } else {
        http.get(this.dufaultUrl, {
          url: window.location.href.split('#')[0]
        }).then(data => {
          const config = {
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'chooseImage', 'getLocalImgData']
          }
          this.wechatObj = new WechatJSSDK(config)
          this.wechatObj.initialize().then(w => {
            this.wxShareFn()
            resolve(w)
          }).catch(err => {
            reject(err)
          })
        })
      }
    })
  },
  wxShareFn: function () {
    let w = this.wechatObj
    w.shareOnChat({
      type: 'link',
      title: this.dufaultParam.title,
      link: this.dufaultParam.link,
      imgUrl: this.dufaultParam.imgUrl,
      desc: this.dufaultParam.desc,
      success: () => {
        (this.dufaultParam.successCallback && typeof (this.dufaultParam.successCallback) === 'function') && this.dufaultParam.successCallback()
      }
    })
    w.shareOnMoment({
      type: 'link',
      title: this.dufaultParam.title,
      link: this.dufaultParam.link,
      imgUrl: this.dufaultParam.imgUrl,
      success: () => {
        (this.dufaultParam.successCallback && typeof (this.dufaultParam.successCallback) === 'function') && this.dufaultParam.successCallback()
      }
    })
  }
}

export default myWx
